import { useSyncExternalStore } from 'react'
import { getTenantSlug, subscribe } from './tenant-store'

/** Aktif dernek slug'ını okur ve değişince bileşeni yeniler. */
export function useTenantSlug(): string | null {
  return useSyncExternalStore(subscribe, getTenantSlug, () => null)
}
